import '../styles/text-block.scss'

const TextBlock = ({ content = '' }) => {
    const html = { __html: content }
    return <div className="text-block" dangerouslySetInnerHTML={html} />
}

export default TextBlock
